import styled, {css} from 'styled-components';

import {ms} from '@yourcoach/shared/styles/normalizeSize';
import {getColor} from '@yourcoach/shared/styles/utils';
import {Text} from '@yourcoach/shared/uikit/Text';
import {View} from '@yourcoach/shared/uikit/View';

export const Container = styled(View)<{
  isActive?: boolean;
  isCoach?: boolean;
  showBadge?: boolean;
}>`
  position: relative;
  height: 100%;
  width: 100%;
  padding-left: ${ms(30)};
  display: grid;
  align-items: center;
  grid-template-columns: 60px auto 1fr;

  ${p =>
    p.isActive &&
    css`
      padding-left: ${ms(26)};
      border-left: 4px solid
        ${p.isCoach ? getColor('border3') : getColor('border6')};
    `}

  &:hover {
    background-color: ${getColor('background6')};
    ${p =>
      p.isCoach &&
      css`
        background-color: ${getColor('background4')};
      `}
  }
  ${p =>
    p.showBadge &&
    css`
      &::before {
        content: '';
        position: absolute;
        top: calc(100% / 2 - 4px);
        left: 60px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: ${getColor('icon5')};
        ${p.isCoach &&
        css`
          background-color: ${getColor('icon4')};
        `}
      }
    `}
`;

export const Icon = styled(({component, ...rest}) => {
  const Component = component;

  return <Component {...rest} />;
})<{$isActive: boolean; $isCoach: boolean}>`
  fill: ${p =>
    p.$isCoach
      ? p.$isActive
        ? getColor('icon4')
        : getColor('icon3')
      : p.$isActive
        ? getColor('icon5')
        : getColor('icon3')};
  width: ${ms(24)};
  height: ${ms(24)};
`;

export const Label = styled(Text)<{
  isActive?: boolean;
  showBadge?: boolean;
}>`
  font-weight: ${p => p.theme.fontWeight.semibold};
  font-size: 0.875rem;
  line-height: ${ms(24)};
  color: ${getColor('text3')};
  white-space: nowrap;
  ${p =>
    p.isActive &&
    css`
      font-weight: ${p.theme.fontWeight.bold};
      color: ${getColor('text1')};
    `}
`;

export const ChildContainer = styled(View)`
  padding-right: 30px;
  justify-content: flex-end;
`;
